import {
  type CardContentProps,
  Card as MuiCard,
  CardContent as MuiCardContent,
} from '@mui/material';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { forwardRef } from 'react';
import { LinearProgress } from '../linearProgress/linearProgress';
import { useCardTokens } from './card.tokens';

type CardProps = {
  children: React.ReactNode | React.ReactNode[];
  variant?: 'elevated' | 'outlined' | 'none';
  sx?: any;
  onClick?: (e?: any) => void;
  hover?: boolean;
  fullWidthOnMobile?: boolean;
  loading?: boolean;
  ref?: any;
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      children,
      variant = 'elevated',
      sx,
      onClick,
      hover = false,
      fullWidthOnMobile = false,
      loading,
    },
    ref,
  ) => {
    const tokens = useThemeTokens(useCardTokens());
    const { comp } = tokens;

    return (
      <MuiCard
        ref={ref}
        onClick={onClick}
        elevation={0}
        sx={{
          borderRadius: {
            xs: fullWidthOnMobile ? '0px' : comp.card?.borderRadius,
            sm: comp.card?.borderRadius,
          },
          background: comp.card.background?.color,
          color: comp.card.text?.color,
          boxShadow: variant === 'elevated' ? comp.card.elevation : 'none',
          border: variant === 'outlined' ? comp.card.border : 'none',
          '&:hover': {
            boxShadow: hover && comp.card.hoverElevation,
            cursor: hover && 'pointer',
          },
          marginLeft: { xs: fullWidthOnMobile ? '-16px' : 0, sm: 0 },
          marginRight: { xs: fullWidthOnMobile ? '-16px' : 0, sm: 0 },
          position: 'relative',
          ...sx,
        }}
      >
        {loading && <LinearProgress sx={{ mb: -0.5 }} />}
        {children}
      </MuiCard>
    );
  },
);
export const CardContent = (props: CardContentProps) => (
  <MuiCardContent
    sx={{ padding: '16px', paddingBottom: '16px', ...props.sx }}
    {...props}
  />
);
